<template>
  <div class="socialization-win-container">
    <!-- point信息 -->
    <div
      class="point"
      @click="detailHandler"
    >
      <img
        class="icon"
        v-show="!showDetail"
        :src="getPointSrc(false)"
        alt=""
      >
      <img
        class="icon-c"
        v-show="showDetail"
        :src="getPointSrc(true)"
        alt=""
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 选中坐标点
    isCurent: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    detailInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    vmm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDetail: this.isCurent,
    };
  },
  watch: {
    isCurent: {
      handler(newValue) {
        this.showDetail = newValue;
      },
      deep: true,
    },
  },
  methods: {
    detailHandler() {
      // this.showDetail = !this.showDetail;
    },
    /**
     * 获取图片地址
     * @param isSelected 图片是否选中
     */
    getPointSrc(isSelected) {
      let icon_name = "";
      if (
        (this.detailInfo.certType == 1 || this.detailInfo.certType == 2 || this.detailInfo.certType == 3) &&
        (this.detailInfo.status == 3 || this.detailInfo.status == 4)
      ) {
        icon_name = `icon_map_${this.detailInfo.certType}`;
      } else {
        if (this.detailInfo.certType == 1 || this.detailInfo.certType == 2 || this.detailInfo.certType == 3) {
          icon_name = `icon_map_${this.detailInfo.certType}_5`;
        } else if (this.detailInfo.status == 3 || this.detailInfo.status == 4) {
          icon_name = `icon_map_4`;
        } else {
          icon_name = `icon_map_5`;
        }
      }

      if (this.detailInfo.certEmergency == 1 && this.detailInfo.certDrying != 1) {
        icon_name = icon_name + "_yj";
      }
      if (this.detailInfo.certDrying == 1 && this.detailInfo.certEmergency != 1) {
        icon_name = icon_name + "_hg";
      }
      if (this.detailInfo.certEmergency == 1 && this.detailInfo.certDrying == 1) {
        icon_name = icon_name + "_yj_hg";
      }
      // 选中
      if (isSelected) {
        icon_name = icon_name + "_c";
      }
      return require(`@/assets/img/cooperative/icon_map/${icon_name}.png`);
    },
  },
};
</script>

<style scoped lang="scss">
.point {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 51px;
  cursor: pointer;
}
.socialization-win-container {
  .modal-content {
    padding-bottom: 10px;
    .info-title {
      margin: 5px 0px;
      color: #ffff9a;
      text-align: left;
      margin-left: -1em;
    }
    .info-detail-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 38px;
      padding: 0 10px 0 12px;
      background: linear-gradient(
        90deg,
        #09b051 0%,
        rgba(9, 173, 80, 0.33) 100%
      );
      box-shadow: 0px -6px 13px 0px rgba(0, 255, 110, 0.22);
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      position: relative;
      div {
        margin-right: 30px;
        .font-left {
          text-align: left;
        }
      }
      .close {
        position: absolute;
        top: 13px;
        right: 13px;
        pointer-events: auto !important;
      }
    }
    .info-detail-tags {
      display: flex;
      align-items: center;
      margin: 8px 16px 2px 16px;
      font-size: 12px;
      color: rgba(255, 159, 36, 1);
      div {
        margin-right: 4px;
      }
      .icon-star {
        width: 12px;
        height: 12px;
      }
      .tag-authentication {
        width: 48px;
        height: 19px;
        margin-right: 8px;
        background: #c49300;
        border-radius: 4px;
        border: 1px solid #fcdb77;
        color: #ffffff;
        text-shadow: 0px 1px 0px #894b00;
        font-style: italic;
      }
      .tag-no-authentication {
        width: 48px;
        height: 19px;
        margin-right: 8px;
        background: rgba(204, 204, 204, 1);
        border-radius: 4px;
        border: 1px solid #f1f1f1;
        color: rgba(102, 102, 102, 1);
        font-style: italic;
      }
    }
    .info-detail-person {
      display: flex;
      margin: 16px 16px 8px 16px;
      img {
        width: 96px;
        height: 96px;
        border-radius: 48px;
        border: 2px solid #e5e5e5;
      }
    }
    .info-detail-item {
      display: flex;
      line-height: 26px;
      padding: 0 16px;
      .title-label {
        font-size: 14px;
      }
      .label {
        width: 96px;
        text-align: left;
        font-size: 14px;
        color: rgba(233, 240, 247, 1);
        margin-right: 8px;
      }
      .label-oil {
        width: 64px;
      }
      .label-transport {
        width: 99px;
        text-align: right;
      }
      .label-work {
        width: 115px;
        text-align: right;
      }
      .label-farm {
        width: 74px;
      }
      .label-person {
        width: 104px;
        text-align: right;
      }
      .value {
        width: 220px;
        color: rgba(13, 255, 169, 1);
        line-height: 26px;
        text-align: left;
        font-size: 14px;
        word-break: break-all;
      }
      .value-font {
        color: rgba(13, 255, 169, 1);
        line-height: 26px;
        text-align: left;
        font-size: 14px;
        word-break: break-all;
      }
      .value-person {
        width: 280px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.title-animation {
  width: 260px;
  white-space: nowrap;
  animation: scroll 6s linear infinite; /* 动画名称、持续时间、动画速度曲线、是否循环 */
}

.four-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
}

.line {
  margin: 10px 16px 0 16px;
  width: 392px;
  border: 1px solid #00d75d;
}

@keyframes scroll {
  from {
    transform: translateX(50%); /* 从右边开始 */
  }
  to {
    transform: translateX(
      -100%
    ); /* 滚动到左边，然后由于无限循环，会从右边重新开始 */
  }
}
</style>
